import { component } from 'picoapp';
import Swiper, { Pagination } from 'swiper';
import app from '../../app';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const config = JSON.parse(node.dataset.config);
  const { productID, baseURL, limit } = config;

  const sliderElement = node.querySelector('.js-slider');
  const paginationElement = node.querySelector('.js-pagination');
  const output = node.querySelector('.js-output');

  /**
   * Functions
   */
  const getMarkup = () => {
    const endpoint = `${baseURL}?section_id=product-related&product_id=${productID}&limit=${limit}`;

    return fetch(endpoint, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then((response) => response.text());
  };

  const initOuterSlider = () => {
    (() => new Swiper(sliderElement, {
      modules: [Pagination],
      slidesPerView: 'auto',
      grabCursor: true,
      pagination: {
        el: paginationElement,
        type: 'bullets',
        bulletClass: 'product-slider__pagination__bullet',
        bulletActiveClass: 'product-slider__pagination__bullet--active',
      },
    }))();
  };

  const mountProductCards = () => {
    // Inner card swipers + deferred hydration live in productMedia (same as collection cards).
    app.mount();
  };

  const init = async () => {
    const markup = await getMarkup();
    const container = document.createElement('div');
    container.innerHTML = markup;

    const fetchedOutput = container.querySelector('.js-output');
    if (!fetchedOutput) return;

    output.innerHTML = fetchedOutput.innerHTML;

    mountProductCards();
    initOuterSlider();
  };

  /**
   * Init
   */
  init();
});
